import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "main-panel" }
const _hoisted_2 = { class: "page-container" }
const _hoisted_3 = { class: "content-card" }
const _hoisted_4 = { class: "content-card-body" }
const _hoisted_5 = { class: "input-row" }
const _hoisted_6 = { class: "field-group" }
const _hoisted_7 = {
  key: 0,
  class: "empty-hint"
}
const _hoisted_8 = { class: "input-row" }
const _hoisted_9 = { class: "field-group" }
const _hoisted_10 = { class: "field-group field-group--wide" }
const _hoisted_11 = ["disabled"]
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 1,
  class: "btn-spinner"
}
const _hoisted_14 = {
  key: 1,
  class: "results-card"
}
const _hoisted_15 = { class: "results-header" }
const _hoisted_16 = { class: "results-count" }
const _hoisted_17 = { class: "ae-results-body" }
const _hoisted_18 = { class: "data-table" }
const _hoisted_19 = { class: "col-num muted" }
const _hoisted_20 = { class: "user-id" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[10] || (_cache[10] = _createElementVNode("div", { class: "page-header" }, [
        _createElementVNode("h1", { class: "page-title" }, "Bulk Credit Upload"),
        _createElementVNode("p", { class: "page-subtitle" }, "Upload a CSV of User Ids to add (or remove) credit for multiple users at once.")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "content-card-header" }, [
          _createElementVNode("span", { class: "card-title" }, "Upload CSV")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _cache[4] || (_cache[4] = _createElementVNode("label", {
                class: "field-label",
                for: "csvFile"
              }, "CSV File (UserId column)", -1)),
              _createElementVNode("input", {
                id: "csvFile",
                class: "field-input",
                type: "file",
                accept: ".csv",
                ref: "fileInput",
                onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onFileSelected && _ctx.onFileSelected(...args)))
              }, null, 544)
            ])
          ]),
          (_ctx.userIds.length)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.userIds.length) + " UserId" + _toDisplayString(_ctx.userIds.length === 1 ? '' : 's') + " parsed from the file. ", 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _cache[5] || (_cache[5] = _createElementVNode("label", {
                class: "field-label",
                for: "creditAmount"
              }, "Credit Amount (£)", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "creditAmount",
                class: "field-input",
                type: "number",
                step: "0.01",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.creditAmount) = $event)),
                placeholder: "e.g. 10 or -10"
              }, null, 512), [
                [
                  _vModelText,
                  _ctx.creditAmount,
                  void 0,
                  { number: true }
                ]
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _cache[6] || (_cache[6] = _createElementVNode("label", {
                class: "field-label",
                for: "description"
              }, "Transaction Description", -1)),
              _withDirectives(_createElementVNode("input", {
                id: "description",
                class: "field-input",
                type: "text",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.description) = $event)),
                placeholder: "e.g. Goodwill gesture for service disruption"
              }, null, 512), [
                [_vModelText, _ctx.description]
              ])
            ])
          ]),
          _createElementVNode("button", {
            class: "btn-add",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.submitBulkCredit && _ctx.submitBulkCredit(...args))),
            disabled: !_ctx.canSubmit || _ctx.isSubmitting
          }, [
            (!_ctx.isSubmitting)
              ? (_openBlock(), _createElementBlock("span", _hoisted_12, "Add Credit"))
              : (_openBlock(), _createElementBlock("span", _hoisted_13))
          ], 8, _hoisted_11),
          (_ctx.results.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _cache[7] || (_cache[7] = _createElementVNode("span", { class: "results-title" }, "Results", -1)),
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.successCount) + " of " + _toDisplayString(_ctx.results.length) + " succeeded", 1)
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("table", _hoisted_18, [
                    _cache[8] || (_cache[8] = _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("th", { class: "col-num" }, "#"),
                        _createElementVNode("th", null, "User ID"),
                        _createElementVNode("th", null, "Status"),
                        _createElementVNode("th", null, "Message")
                      ])
                    ], -1)),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.results, (result, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", _hoisted_19, _toDisplayString(index + 1), 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", _hoisted_20, _toDisplayString(result.userId), 1)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("span", {
                              class: _normalizeClass(result.isSuccess ? 'status-success' : 'status-error')
                            }, _toDisplayString(result.isSuccess ? 'Success' : 'Failed'), 3)
                          ]),
                          _createElementVNode("td", null, _toDisplayString(result.message), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ])
  ]))
}